import React from "react";

import "./styles/main.scss";

const ClickFinanceLayout = ({ children, formName, logo }) => (
  <div className='layout-click-finance'>
    <header>
      <div className="container">
        <a href="/">
          <img src={logo} alt="" className="logo" />
        </a>
        <ul className="menu menu-nopadding">
          <li>
            <h1>{formName} - Application</h1>
          </li>
        </ul>

        <ul className="menu login">
          <li>
            <a href="mailto:info@oneregistryservices.com.au">
              info@oneregistryservices.com.au
            </a>
          </li>
          <li>
            <a href="tel:02 8188 1510">02 8188 1510</a>
          </li>
        </ul>
      </div>
    </header>
    <div className='banner' />
    <div className='container'>
      <main className='content'>{children}</main>
    </div>
  </div>
);

export default ClickFinanceLayout;
